import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {

  getPermissions(params) {
    return axiosInstance.get('/master/permission', { params, cancelToken: getNewCancelToken() });
  },
  getPermissionById(id, params) {
    return axiosInstance.get(`/master/permission/${id}`, { params, cancelToken: getNewCancelToken() });
  },
  createPermission(data) {
    return axiosInstance.post('/master/permission', data, { cancelToken: getNewCancelToken() });
  },
  deletePermission(id) {
    return axiosInstance.delete(`/master/permission/${id}`, { cancelToken: getNewCancelToken() });
  },
  updatePermission(id, data) {
    return axiosInstance.put(`/master/permission/${id}`, data, { cancelToken: getNewCancelToken() });
  },
};
